module.exports = __webpack_public_path__ + "img/webhook.062cd47.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/webhook.png
// module id = 28fE
// module chunks = 39 44